import { useQuery } from '@tanstack/react-query';
import { getMyEarnings } from '../services/earningsService';

/**
 * Chef's Pending-segment feed. Cached under ['earnings'] so any future
 * mutation that affects an order's payment/snapshot state can invalidate
 * this list in one shot.
 *
 * `enabled` exists for the profile menu, which mounts at the app root for
 * every signed-in user and only wants this data for chefs — the endpoint is
 * caller-scoped, so a non-chef (or logged-out) mount must not call it. The
 * My Earnings page leaves it defaulted: it gates on chef persona before
 * mounting, and shares this cache entry with the menu.
 */
export function useMyEarnings(enabled = true) {
  return useQuery({
    queryKey: ['earnings'],
    queryFn: () => getMyEarnings(),
    enabled,
  });
}
